import React, { useState, useRef, useEffect } from 'react';
import { isAndroidApp } from '../../../core/util/device';
import { NativeFunctions } from '../../../core/util/native';

type Props = {
  onClick?: (...args: any[]) => any;
  accept?: string;
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

const FileUpload = (props: Props) => {
  const [capturedEvent, setCapturedEvent] = useState(null);
  const [responseReceived, setResponseReceived] = useState(false);
  const inputRef = useRef();

  const handleRequestPermissionsResponse = () => setResponseReceived(true);

  const handleClick = (event: any) => {
    const { nativeEvent } = event;

    if (isAndroidApp() && !nativeEvent.recaptured) {
      const clonedEvent = new MouseEvent('click', nativeEvent);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'recaptured' does not exist on type 'Mous... Remove this comment to see the full error message
      clonedEvent.recaptured = true;

      // @ts-expect-error ts-migrate(2345) FIXME: Type 'MouseEvent' provides no match for the signat... Remove this comment to see the full error message
      setCapturedEvent(clonedEvent);

      event.stopPropagation();
      event.preventDefault();

      NativeFunctions.requestCameraPermissions.call();
    } else props.onClick && props.onClick(event);
  };

  useEffect(() => {
    document.addEventListener('message', handleRequestPermissionsResponse);
    return () => document.removeEventListener('message', handleRequestPermissionsResponse);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (responseReceived && capturedEvent) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      inputRef.current.dispatchEvent(capturedEvent);
      props.onClick && props.onClick(capturedEvent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [capturedEvent, responseReceived]);

  // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'HTMLIn... Remove this comment to see the full error message
  return <input {...props} onClick={handleClick} ref={inputRef} />;
};

export default FileUpload;
